import { IconButton, Link, makeStyles, Paper, SvgIcon, Theme } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import WrapTextIcon from '@material-ui/icons/WrapText';
import React from 'react';

import { ReactComponent as PinSvg } from '../../../../assets/pin.svg';
import { colorPalette, spacings } from '../../../../theme';

type Props = {
  url: string;
  viewAction: 'open_in_new_tab' | 'download';
  isPrimaryLink: boolean;
  onSetAsPrimaryLink: () => void;
  onInline: () => void;
};

export const AttachmentMenu = ({
  url,
  viewAction,
  onInline,
  isPrimaryLink,
  onSetAsPrimaryLink,
}: Props): React.ReactElement => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <div className={classes.actions}>
        {viewAction === 'open_in_new_tab' && (
          <Link href={url} tabIndex={-1} target="_blank" rel="noopener noreferrer">
            <IconButton className={classes.action} size="small" tabIndex={1}>
              <OpenInNewIcon />
            </IconButton>
          </Link>
        )}

        {viewAction === 'download' && (
          // TODO: note that images are not downloaded: https://stackoverflow.com/questions/49736214/force-a-download-to-download-image-instead-of-opening-url-link-to-image
          <Link href={url} tabIndex={-1} download={url} target="_blank" rel="noopener noreferrer">
            <IconButton className={classes.action} size="small" tabIndex={1}>
              <SaveAltIcon />
            </IconButton>
          </Link>
        )}

        <IconButton className={classes.action} onClick={onSetAsPrimaryLink} size="small" tabIndex={1}>
          <SvgIcon>
            <PinSvg className={isPrimaryLink ? classes.iconColorEnabled : classes.iconColorDefault} />
          </SvgIcon>
        </IconButton>

        <IconButton className={classes.action} onClick={onInline} size="small" tabIndex={1}>
          <WrapTextIcon />
        </IconButton>
      </div>
    </Paper>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    color: theme.palette.common.black,
    padding: spacings.small,

    display: 'flex',
    justifyContent: 'space-between',
  },
  actions: {
    display: 'flex',
  },
  action: {
    background: '#FFFFFF',
    border: '1px solid #E5E5E5',
    borderRadius: 360,

    margin: `0 ${spacings.xsmall}px`,
  },
  iconColorDefault: {
    fill: 'currentColor',
  },
  iconColorEnabled: {
    fill: colorPalette.primaryColorBlue._500,
  },
}));
